import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var identityProofConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: true,
  stepDetailsProps: {
    title: 'STEP 11',
    heading: 'Local Refernce Identity Proof',
    avatarIcon: 'IdCardIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  uploadDataText: 'Upload Documents',
  inputsDataProps: {
    addressProof: {
      label: 'Address Proof Number',
      showAppend: false,
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter address proof number',
      inputRegex: '^[0-9]*$'
    },
    identityProof: {
      label: 'Identity Proof Number',
      showAppend: false,
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter proof of address types',
      inputRegex: '^[0-9]*$'
    }
  },
  calloutProps: {
    description: 'As per DOT rules, share local reference ID proof if your permanent address is in a different city.',
    state: 'lilac',
    iconName: 'InfoIcon'
  },
  submitButtonProps: {
    leftCta: {
      version: 'variable-width',
      title: 'Verify Aadhaar Via OTP',
      size: 'md'
    }
  },
  checkboxProps: {
    label: 'Proof of identity same as address proof',
    value: 'agree_T&C'
  },
  dropdownsDataProps: {
    addressProofDropDown: {
      placeholder: 'select document type',
      label: 'Address Proof',
      postfixIconName: 'DownChevronIcon',
      variant: 'none',
      filterKey: 'subHeading'
    },
    idProofDropDown: {
      placeholder: 'select document type',
      label: 'Identity Proof',
      postfixIconName: 'DownChevronIcon',
      variant: 'none',
      filterKey: 'subHeading'
    }
  },
  uploadsDataProps: {
    uploadFrontIdProof: {
      uploadContainer: {
        id: '103',
        uploadCtaTitle: 'Upload',
        postfixTitle: 'front Side',
        description: 'Only jpg, png with max size of 5 MB',
        onUploadCtaPress: {
          id: 'uploadFrontAddressProof'
        }
      },
      allowFileUploadOnWeb: true,
      uploadedFiles: [{
        hintText: 'can’t upload the file, size shouldn’t exceed above 5 MB',
        actionCtaText: 'RETRY',
        onActionCtaPress: {
          id: 'retry-press'
        }
      }]
    },
    uploadBackIdProof: {
      uploadContainer: {
        id: '104',
        uploadCtaTitle: 'Upload',
        postfixTitle: 'back Side',
        description: 'Only jpg, png with max size of 5 MB',
        onUploadCtaPress: {
          id: 'uploadBackAddressProof'
        }
      },
      allowFileUploadOnWeb: true,
      uploadedFiles: [{
        hintText: 'can’t upload the file, size shouldn’t exceed above 5 MB',
        actionCtaText: 'RETRY',
        onActionCtaPress: {
          id: 'retry-press'
        }
      }]
    },
    uploadFrontAddressProof: {
      uploadContainer: {
        id: '101',
        uploadCtaTitle: 'Upload',
        postfixTitle: 'front Side',
        description: 'Only jpg, png with max size of 5 MB',
        onUploadCtaPress: {
          id: 'uploadFrontAddressProof'
        }
      },
      allowFileUploadOnWeb: true,
      uploadedFiles: [{
        hintText: 'can’t upload the file, size shouldn’t exceed above 5 MB',
        actionCtaText: 'RETRY',
        onActionCtaPress: {
          id: 'retry-press'
        }
      }]
    },
    uploadBackAddressProof: {
      uploadContainer: {
        id: '102',
        uploadCtaTitle: 'Upload',
        postfixTitle: 'back Side',
        description: 'Only jpg, png with max size of 5 MB',
        onUploadCtaPress: {
          id: 'uploadBackAddressProof'
        }
      },
      allowFileUploadOnWeb: true,
      uploadedFiles: [{
        hintText: 'can’t upload the file, size shouldn’t exceed above 5 MB',
        actionCtaText: 'RETRY',
        onActionCtaPress: {
          id: 'retry-press'
        }
      }]
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};